import styled from "styled-components";

export const BtnArrowRightStyled = styled.div`
  .btn_arrow_right {
    border-radius: 24px;
    padding: 13px 13px 13px 24px;
    width: 100%;
    height: ${({ height }) => (height ? height : "48px")};
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: ${({ theme }) => theme.COLORS.WHITE_1};
    background: ${({ theme }) => theme.COLORS.PURPLE_1};
    font-size: ${({ theme }) => theme.FONT.SIZE.S14};
    font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_REGULAR};
    cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
  }

  .theme_text_center {
    justify-content: none;
    .btn_arrow_right {
      .label {
        flex: 1;
        text-align: center;
      }
    }
  }
`;
